/**
 * all states from store
 */
export default {
  course_opened: null,
  course: {},
  count_course_next: 0,
  finished: false,
};
